var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"start"}},[_c('v-col',{attrs:{"cols":"auto"}},[_c('h1',{staticClass:"ma-3"},[_vm._v(_vm._s(_vm.$store.state.user.user.name)+"'s Boards")])])],1),_c('the-boards')],1)}
var staticRenderFns = []

export { render, staticRenderFns }